// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsLibraryPage_container__oCGHN","linksContainer":"NewsLibraryPage_linksContainer__I24iZ","filterSection":"NewsLibraryPage_filterSection__wWySQ"};